import { action } from 'utils/actions'

export const PROMO_CODE_LOAD_PARTNER_CODES = 'PROMO_CODE_LOAD_PARTNER_CODES'
export const PROMO_CODE_SET_EDITING_PROMO_CODE = 'PROMO_CODE_SET_EDITING_PROMO_CODE'
export const PROMO_CODE_CREATE = 'PROMO_CODE_CREATE'
export const PROMO_CODE_EDIT = 'PROMO_CODE_EDIT'

export const promoCodeLoadPartnerCodes = partnerId =>
  action(PROMO_CODE_LOAD_PARTNER_CODES, { partnerId })

export const promoCodeSetEditingPromoCode = promoCodeId =>
  action(PROMO_CODE_SET_EDITING_PROMO_CODE, { promoCodeId })

export const promoCodeCreate = (partnerId, values) =>
  action(PROMO_CODE_CREATE, { partnerId, values })

export const promoCodeEdit = (promoCodeId, values) =>
  action(PROMO_CODE_EDIT, { promoCodeId, values })



/** WEBPACK FOOTER **
 ** ./src/actions/promo-code/promo-code-actions.js
 **/